<template>
	<div class="Hero" 
		:class="{
			'Hero--primary': color === 'primary',
			'Hero--black': color === 'black',
		}"
		>
		<!-- Text container -->
		<div class="Hero-text">
			<slot name="text" />
		</div>
		<!-- Image container -->
		<div class="Hero-image">
			<slot name="image" />
		</div>
	</div>
</template>

<script>
	
	export default {
		name: "CloHero",
		components: {

		},
		data() {
			return {};
		},
		props: {
			color: String,
		},
		computed: {
			classes: function () {
				switch (this.color) {
					case 'primary':
						return 'Hero--primary';
						break;
					case 'black':
						return 'Hero--black';
						break;
					default:
						return '';
						break;
				}
			},
		},
	};
</script>

<style lang="scss">
	.Hero {
		background-color: $color-neutral-5;
		background-color: var(--heroBackgroundColor, $color-neutral-5);
		@include breakpoint(medium) {
			display: grid;
			grid-template-columns: 1fr 70%;
			grid-template-rows: auto;
			grid-template-areas:
				"text image image"
				"text image image";
			align-items: end;
		}
	}
	.Hero-text {
		grid-area: text;
		@include inset-responsive;
	}
	.Hero-image {
		grid-area: image;
		align-self: stretch;
		display: flex;
		align-items: center;
		justify-content: center;
		.ImageAspectRatio .AspectRatioContent {
			background-color: transparent;
		}
	}

	// Variants
	.Hero--primary {
		background-color: $color-primary-5;
		background-color: var(--heroBackgroundColor, $color-primary-5);
	}
	.Hero--black {
		background-color: $color-black;
		background-color: var(--heroBackgroundColor, $color-black);
	}

	.print .Hero {
		background-color: transparent !important;
		display: block;
		.Hero-text,
		.Hero-image {
			padding: 0;
			margin-bottom: $space-md;
		}
	}
</style>